<template>
  <CommonModal @onClose="onClose" :title="'Комментарий'">
    <template #body>
      <div :class="$style.container">
        <div :class="$style.content">
          <textarea
            v-model="comment"
            :class="$style.top"
            placeholder="Add comments..."
          ></textarea>
          <div :class="$style.bottom">
            <div :class="$style.attachments">
              <div
                v-if="isSettingsOpen"
                @click="isSettingsOpen = false"
                :class="$style.backdrop"
              ></div>
              <div v-if="isSettingsOpen" :class="[$style.settings]">
                <div v-if="isEnabledGalery" @click="isSettingsOpen = false">
                  <img src="/icons/common/add-file-black.svg" alt="" />
                  Выбрать файл
                  <input
                    @change="setFile($event, 'files')"
                    accept=".pdf,.doc,.docx,.txt,.rtf,.odt,.xls,.xlsx,.ppt,.pptx"
                    type="file"
                    multiple
                  />
                </div>
                <div v-if="isEnabledGalery" @click="isSettingsOpen = false">
                  <img src="/icons/common/add-image-black.svg" alt="" />
                  Выбрать фото
                  <input
                    @change="setFile($event, 'files')"
                    accept="image/*"
                    type="file"
                    multiple
                  />
                </div>
                <div @click="isSettingsOpen = false" :class="$style.mobile">
                  <img src="/icons/common/open-image-black.svg" alt="" />
                  Открыть камеру
                  <input
                    @change="setFile($event, 'files')"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    multiple
                  />
                </div>
              </div>
              <div
                :class="[$style.left, { [$style.hidden]: !isEnabledGalery }]"
              >
                <img
                  @click="isSettingsOpen = !isSettingsOpen"
                  src="/icons/common/add-file.svg"
                  alt=""
                />
                <div :class="$style.files">
                  <div v-for="file in files" :key="file.name">
                    {{ truncateFileName(file.name) }}
                    <img src="/icons/common/cross-black.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div @click="save" :class="$style.button">Отправить</div>
          </div>
        </div>
      </div>
    </template>
  </CommonModal>
</template>

<script>
import Repository from "@/repository";
import CommonModal from "@/components/modals/CommonModal.vue";
import { mapState } from "vuex";
export default {
  components: {
    CommonModal,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formData: new FormData(),
      comment: "",
      files: [],
      geolocationSupported: "geolocation" in navigator,
      location: null,
      isSettingsOpen: false,
      isEnabledGalery: false,
    };
  },
  async mounted() {
    await this.getUser();
  },
  methods: {
    onClose() {
      this.$store.commit("setIconsModals", {
        modal: "comment",
        value: false,
      });
    },
    async save() {
      await this.getUserLocation();

      this.formData.append(
        "coordinates",
        JSON.stringify({
          type: "Point",
          coordinates: [this.location.longitude, this.location.latitude],
        })
      );
      this.formData.append("text", this.comment);

      await Repository.Supervision.Analytics.addComment({
        id: this.id,
        payload: this.formData,
      });
      this.files = [];
      this.comment = "";
      this.formData = new FormData();
      this.$store.commit("setIconsModals", {
        modal: "comment",
        value: false,
      });
    },
    async setFile(e, type) {
      this.formData.append(type, e.target.files[0]);
      this.files.push(e.target.files[0]);
    },
    async getUserLocation() {
      if (!this.geolocationSupported) return;

      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          });
        });

        this.location = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          //timestamp: new Date(position.timestamp),
        };
        console.log(this.location);

        // Опционально: получить адрес по координатам
      } catch (error) {
        alert(
          "Не удалось получить ваше местоположение. Пожалуйста, разрешите доступ к геолокации."
        );
      }
    },
    truncateFileName(name) {
      if (name.length > 15) {
        return name.slice(0, 6) + "..." + name.slice(-5);
      }
      return name;
    },
    async getUser() {
      const { value, error } = await Repository.Users.getOne(
        this.supervision.user.id
      );
      if (value && value.enable_file_upload_only_from_camera) {
        this.isEnabledGalery = true;
      }
    },
  },
  computed: {
    ...mapState({
      supervision: (state) => state.supervision.supervision,
    }),
  },
};
</script>

<style lang="scss" module>
.container {
  .content {
    padding: 1rem;
    background-color: $background;
    margin: 5.125rem 0 0 0;
    border-radius: 0.5rem;
    .top {
      margin: 0 0 1rem 0;
      width: 100%;
      height: 6.8125rem;
      resize: none;
      border: none;
      background-color: $background;
      font-weight: 400;
      font-size: 1rem;
      @include scrollbarY;
      &::placeholder {
        font-weight: 400;
        font-size: 1rem;
        color: $t-secondary;
      }
    }
    .bottom {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 1rem;
      @include custom(988) {
        flex-direction: column;
        align-items: flex-start;
      }
      .attachments {
        position: relative;
        display: flex;
      }
      .backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 71;
        cursor: default;
      }
      .settings {
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: $bg-white;
        padding: 1rem;
        border-radius: 1rem;
        cursor: pointer;
        z-index: 72;
        div {
          display: flex;
          align-items: center;
          white-space: nowrap;
          gap: 0.5rem;
          margin: 1rem 0 0 0;
          cursor: pointer;
          position: relative;
          input {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            height: 100%;
            width: 100%;
            cursor: pointer;
          }
          &:first-child {
            margin: 0;
          }
          &.mobile {
            display: none;
            @include custom(988) {
              display: flex;
            }
          }
        }
      }
      .left {
        display: flex;
        align-items: flex-end;
        gap: 1rem;
        img {
          cursor: pointer;
        }
        &.hidden {
          display: none;
          @include custom(988) {
            display: flex;
          }
        }
      }
      .file {
        width: 1.5rem;
        img {
          cursor: pointer;
          position: relative;
          top: 1.5rem;
        }
        input {
          opacity: 0;
          width: 100%;
          cursor: pointer;
        }
      }
      .files {
        div {
          background-color: $t-white;
          border-radius: 2rem;
          padding: 0.25rem 0.75rem;
          display: flex;
          align-items: center;
          gap: 1rem;
          white-space: nowrap;
          img {
            cursor: pointer;
          }
          margin: 0 0 0.25rem 0;
          &:last-child {
            margin: 0;
          }
        }
      }
      .button {
        white-space: nowrap;
        background-color: $black;
        color: $t-white;
        padding: 0.75rem 3.625rem;
        border-radius: 0.5rem;
        cursor: pointer;
        @include custom(988) {
          padding: 0.75rem 1.5rem;
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}
</style>
